import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';
import HomeReducer from './home.reducer';
import ProductReducer from './product.reducer';
import CartReducer from './cart.reducer';
import LoginReducer from './login.reducer';
import AddressReducer from './address.reducer';
import CheckoutReducer from './checkout.reducer';
import SearchReducer from './search.reducer';
import CategoriesReducer from './categories.reducer';
import UserReducer from './user.reducer';
import TaxAddressReducer from './tax-address.reducer';
import LanguageReducer from './language.reducer';
import NavigationReducer from './navigation.reducer';
import PaymentType from './payment-type.reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    form,
    language: LanguageReducer,
    home: HomeReducer,
    login: LoginReducer,
    product: ProductReducer,
    search: SearchReducer,
    cart: CartReducer,
    address: AddressReducer,
    checkout: CheckoutReducer,
    categories: CategoriesReducer,
    user: UserReducer,
    taxaddress: TaxAddressReducer,
    navigation: NavigationReducer,
    payment: PaymentType,
  });
